export enum VariableDataType {
    Text = 0,
    Numeric = 1,
    Image = 2,
    Date = 3,
    File = 4,
    Base64 = 5,
}
